import { AfterViewInit, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import * as FileSaver from 'file-saver';
import * as moment from 'moment';
import { Table } from 'primeng/table';
import { Observable, map, startWith } from 'rxjs';
import { MyErrorStateMatcher } from 'src/app/auth/login/login.component';
import { UserService } from 'src/app/shared/user.service';
import { NotificationService } from '../../notifications/shared/notification.service';
import { Contract } from '../../shared/contract.model';
import { ContractService } from '../../shared/contract.service';
import { KpiDialogComponent } from '../kpi-dialog/kpi-dialog.component';
import { TotalRecordCountService } from './total-record-count.service';
interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-result-search',
  templateUrl: './result-search.component.html',
  styleUrl: './result-search.component.scss'
})

export class ResultSearchComponent implements AfterViewInit {
  @ViewChild('dt') dt: Table;
  scrollHeight: string = 'calc(100vh - 300px)';
  isLoading: boolean = false;
  id: any;
  mode: string;
  isNotFound: boolean = false;
  contractTypes: any;
  filteredOptions: Observable<string[]>;
  defaultAttributes: any = ["Contract Id", "Contract Name", "Contract Status"];
  metaData: any = [];
  formLoading = false;
  allUsers: [] = [];
  contractStatus: [] = [];
  selectedValues: any[] = [];
  selectedContract!: Contract[];
  notificationForm: FormGroup;
  matcher = new MyErrorStateMatcher();

  values: string[] = [];
  statuses!: any[];
  allContract!: Column[];
  selectedAllContract!: Column[];
  contractList !: Contract[];
  attributesList: any[]
  totalRecords: any = 0;
  selectedColumns!: Column[];

  loading: boolean = true;
  attributeColumns: Column[] = [];
  allColumnsWithAttributes: Column[] = [];

  tableScrollable: boolean = false;

  constructor(
    private route: ActivatedRoute,
    public service: NotificationService,
    private contractService: ContractService,
    private userServise: UserService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private totalRecordCountService: TotalRecordCountService,
    private cd: ChangeDetectorRef) {
    this.route.params.subscribe(params => {
      this.id = params['id'];
      this.mode = params['mode'];
    });

    this.notificationForm = this.fb.group({

      contractTypeName: [''],
      contractTypeId: [0]
    });
  }
  async ngOnInit() {
    this.getContract()
    await this.service.getContractType().then((res) => {
      this.contractTypes = res as Array<Object>;
      this.contractTypes.unshift({ contractTypeId: null, name: 'All' });
    });

    if (this.contractTypes) {
      this.filteredOptions = this.notificationForm.get('contractTypeName').valueChanges.pipe(
        startWith(''),
        map(value => this._filter(((value as string)) || ''))
      );
    }
    // 

    this.formLoading = false;

    this.allContract = [
      { field: 'contract', header: 'Contract Name' },
      { field: 'contractType', header: 'Contract Type' },
      { field: 'createdBy', header: 'Create By' },
      { field: 'createdDate', header: 'Create Date' },
      { field: 'updateDate', header: 'Last UpdateDate' },
      { field: 'status', header: 'Status' },
      // {field: 'attributes',header:'MetaData'}

    ];
    this.selectedAllContract = this.allContract

    // After fetching contracts, extract all unique attribute keys
    this.extractAttributeColumns();
  }

  clear(table: Table) {
    table.clear();
  }
  ngAfterViewInit(): void {
    this.dt.onFilter.subscribe(() => {
      if (this.dt.filteredValue) {
        const filteredDataLength = this.dt.filteredValue.length;
        this.totalRecordCountService.setTotalRecordCount(filteredDataLength);
      }
    });

    // Initial check for column count
    this.updateTableScrolling();
  }

  // Update the table scrolling method
  private updateTableScrolling(): void {
    const shouldScroll = this.selectedAllContract && this.selectedAllContract.length > 7;
    this.tableScrollable = shouldScroll;

    // Force change detection to update the view
    this.cd.detectChanges();
  }

  // Update the existing onColumnSelect method or add it if it doesn't exist
  onColumnSelect(): void {
    this.updateTableScrolling();
  }

  async getContract() {
    await this.contractService.getContractTypeAttribute().then((allContracts: any) => {
      this.contractList = allContracts.body;
      this.attributesList = allContracts.body.map(item => item.attributes);

      // Process the contract list to flatten attributes
      this.processContractList();

      // Process dates - store both raw and formatted dates
      this.contractList.forEach((data: any) => {
        // For createDate/createdDate
        if (data.createDate) {
          const rawDate = data.createDate || data.createdDate;
          // Store raw Date object for filtering
          data.createdDate = moment(rawDate).toDate();
          // Store formatted string for display
          data._createdDateFormatted = moment(rawDate).isValid() ? moment(rawDate).format("lll") : rawDate;
        }

        // For updateDate/updatedDate
        if (data.updateDate || data.updatedDate) {
          const rawDate = data.updateDate || data.updatedDate;
          // Store raw Date object for filtering
          data.updateDate = moment(rawDate).toDate();
          // Store formatted string for display
          data._updateDateFormatted = moment(rawDate).isValid() ? moment(rawDate).format("lll") : rawDate;
        }
      });

      this.loading = false;
      this.totalRecords = this.contractList.length;
      this.totalRecordCountService.setTotalRecordCount(this.totalRecords);

      // Extract attribute columns after data is loaded
      this.extractAttributeColumns();
    });
  }

  // Process contract list to flatten attributes
  processContractList() {
    this.contractList.forEach(contract => {
      // Handle standard date fields first
      if (contract.createDate || contract.createdDate) {
        const rawDate = contract.createDate || contract.createdDate;
        contract.createdDate = moment(rawDate).toDate();
        contract._createdDateFormatted = moment(rawDate).isValid() ? moment(rawDate).format("lll") : rawDate;
      }

      if (contract.updateDate || contract.updatedDate) {
        const rawDate = contract.updateDate || contract.updatedDate;
        contract.updateDate = moment(rawDate).toDate();
        contract._updateDateFormatted = moment(rawDate).isValid() ? moment(rawDate).format("lll") : rawDate;
      }

      if (contract.attributes) {
        // List of known date field names in attributes
        const dateFieldNames = [
          'Agreement Start Date',
          'Agreement Expiry Date',
          'Termination Date',
          'Effective Date',
          'End Date',
          'Start Date',
          'Termination Date',
          'Offer Release Date',
          'Offer Start Date',
          'Offer End Date',
          'Created Date',
          'Updated Date'
        ];

        // Flatten attributes into top-level properties
        Object.keys(contract.attributes).forEach(key => {
          const fieldName = `attr_${key.replace(/\s+/g, '_')}`;
          const value = contract.attributes[key];

          if (dateFieldNames.includes(key)) {
            // For date fields, we want to store null values as null
            // but convert valid dates to Date objects
            if (value === null || value === undefined || value === '') {
              contract[fieldName] = null;
              contract[`${fieldName}_formatted`] = '';
            } else {
              try {
                const momentDate = moment(value);
                if (momentDate.isValid()) {
                  // Store raw Date object for filtering
                  contract[fieldName] = momentDate.toDate();
                  // Store formatted string for display
                  contract[`${fieldName}_formatted`] = momentDate.format("lll");
                } else {
                  contract[fieldName] = value;
                  contract[`${fieldName}_formatted`] = value;
                }
              } catch (e) {
                contract[fieldName] = value;
                contract[`${fieldName}_formatted`] = value;
              }
            }
          } else {
            // For non-date fields, store the value as is
            contract[fieldName] = value;
          }
        });
      }
    });
  }

  // Helper method to check if a string is likely a date
  private isDateString(value: string): boolean {
    // Check common date formats (YYYY-MM-DD, MM/DD/YYYY, etc.)
    const datePatterns = [
      /^\d{4}-\d{2}-\d{2}$/, // YYYY-MM-DD
      /^\d{2}\/\d{2}\/\d{4}$/, // MM/DD/YYYY
      /^\d{2}-\d{2}-\d{4}$/, // DD-MM-YYYY
      /^\d{1,2}\s+(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\s+\d{4}$/i // DD Mon YYYY
    ];

    return datePatterns.some(pattern => pattern.test(value.trim())) && moment(value).isValid();
  }

  // Extract all unique attribute keys from contracts and create columns
  extractAttributeColumns() {
    if (!this.contractList || this.contractList.length === 0) return;

    const attributeKeys = new Set<string>();

    // Collect all unique attribute keys
    this.contractList.forEach(contract => {
      if (contract.attributes) {
        Object.keys(contract.attributes).forEach(key => {
          attributeKeys.add(key);
        });
      }
    });

    // Create columns for each attribute key
    this.attributeColumns = Array.from(attributeKeys).map(key => ({
      field: `attr_${key.replace(/\s+/g, '_')}`,
      header: key
    }));

    // Combine standard columns with attribute columns
    this.allColumnsWithAttributes = [...this.allContract, ...this.attributeColumns];

    // Update selected columns to include both standard and attribute columns
    // this.selectedAllContract = this.allColumnsWithAttributes;
    console.log(this.attributeColumns)
  }

  updateFilteredRecordsCount(): void {
    this.totalRecords = this.dt.filteredValue ? this.dt.filteredValue.length : 0;
    this.totalRecordCountService.setTotalRecordCount(this.totalRecords);
  }

  onInputChange(value: string) {
    this.filteredOptions = this.notificationForm.get('contractTypeName').valueChanges.pipe(
      startWith(value),
      map(val => this._filter((val as string) || ''))
    );
  }
  private _filter(value: string): any[] {
    this.isNotFound = false;
    const filterValue = value.toLowerCase();
    const results = this.contractTypes.filter(option => option.name.toLowerCase().includes(filterValue));
    if (results.length === 0)
      this.isNotFound = true

    return results;
  }
  async onContractTypeSelect(event) {
    this.notificationForm.get('contractTypeName').setValue(event.option.value.name);
    this.notificationForm.get('contractTypeId').setValue(event.option.value.contractTypeId ?? 0);

    if (this.contractTypes) {
      this.filteredOptions = this.notificationForm.get('contractTypeName').valueChanges.pipe(
        startWith(''),
        map(value => this._filter((value as string) || ''))
      );
    }

    await this.service.getContractMetadata(event.option.value.contractTypeId).then((res: any) => {
      this.metaData = [...this.defaultAttributes, ...res.attributes];
      console.log(this.metaData);

      // Update columns to include attributes relevant to the selected contract type
      if (res.attributes && res.attributes.length > 0) {
        const attributeColumns = res.attributes.map(attr => ({
          field: `attr_${attr.replace(/\s+/g, '_')}`,
          header: attr
        }));
        this.attributeColumns = attributeColumns;
        this.allColumnsWithAttributes = [...this.allContract, ...this.attributeColumns];
        this.selectedAllContract = this.allContract;
      }
    });
  }
  // onSelected(event) {
  //   const selectedField = event.value.field;
  //   const selectedHeader = event.value.header;
  //   this.allContract.push({ field: selectedField, header: selectedHeader });


  // }

  getSeverity(status: string) {
    switch (status) {
      case 'unqualified':
        return 'danger';

      case 'qualified':
        return 'success';

      case 'new':
        return 'info';

      case 'negotiation':
        return 'warning';

      case 'renewal':
        return null;
    }
  }

  exportExcel(data: any[], fileName: string) {
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(data);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, fileName);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }


  exporContractsList() {
    const renderedData = this.dt.filteredValue || this.dt.value;
    const dataToExport = renderedData.map(item => {
      const baseData: any = {};

      // Only include the selected columns
      this.selectedAllContract.forEach(col => {
        if (col.field.startsWith('attr_')) {
          // Handle attribute columns
          const attrName = col.header;
          baseData[attrName] = item[col.field] || (item.attributes && item.attributes[attrName]);
        } else {
          // Handle regular columns
          baseData[col.header] = item[col.field];
        }
      });

      return baseData;
    });

    this.exportExcel(dataToExport, 'contracts_export');
  }
  async openSaveKpi() {
    const dialogRef =
      this.dialog.open(KpiDialogComponent, {
        enterAnimationDuration: '400ms',
        exitAnimationDuration: '500ms',
        width: '40%',
        disableClose: true,

      });
  }

  // Helper method to check if an attribute field is a date
  isDateAttribute(field: string): boolean {
    if (!field.startsWith('attr_')) {
      return false;
    }

    // Get the original attribute name from the field
    const attributeName = field.replace('attr_', '').replace(/_/g, ' ');
    
    // List of known date fields
    const dateFieldNames = [
      'Agreement Start Date',
      'Agreement Expiry Date',
      'Termination Date',
      'Effective Date',
      'End Date',
      'Start Date',
      'Termination Date',
      'Offer Release Date',
      'Offer Start Date',
      'Offer End Date',
      'Created Date',
      'Updated Date',
      'Date of Joining'
    ];

    return dateFieldNames.includes(attributeName);
  }

}


